import React, {useState, useEffect, useCallback} from 'react';
import {API_ENDPOINTS} from "../../../apiConfig";
import API from "../../../utils/API";
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import AdminDataView from "../../../components/AdminDataView";

const PartLogs = () => {
    const [partLogs, setPartLogs] = useState([]);
    const {t} = useTranslation();

    const fetchCategories = useCallback(async () => {
        try {
            const {data} = await API.get(API_ENDPOINTS.partLog.list);
            setPartLogs(data);
        } catch (error) {
            console.error("Failed to fetch devices:", error);
        }
    }, []);

    useEffect(() => {
        fetchCategories();
    }, []);

    const columns = [
        {
            key: 'part',
            name: t('part'),
            renderCell: ({row}) => `${row.part?.name || '-'} - ${(row.part?.part?.compatibleWith || []).map(device => device.name).join(', ')}`
        },
        {
            key: 'amount',
            name: t('amount')
        },
        {
            key: 'prevQuantity',
            name: t('stockQuantityInfo'),
            renderCell: ({row}) => `${row.prevQuantity} / ${row.newQuantity}`
        },
        {
            key: 'createdBy',
            name: t('createdBy'),
            renderCell: ({row}) => `${row.createdBy.name} ${row.createdBy.surname}`
        },
        {
            key: 'createdAt',
            name: t('createdAt'),
            renderCell: ({row}) => moment(row.createdAt).format('DD.MM.YYYY HH:mm')
        }
    ].map(column => ({...column, resizable: true}));

    return (
        <div>
            <AdminDataView section="part-logs" rows={partLogs} columns={columns}/>
        </div>
    );
};

export default PartLogs;
